import { useEffect } from 'react';

interface PageMetadataProps {
  title: string;
  description: string;
  keywords?: string;
}

// Location-specific keywords
export const NAGPUR_KEYWORDS = 'print shops in nagpur';

// General keywords that apply to all locations
export const DEFAULT_KEYWORDS = 'printing near me, printing, print shop near me, print shop closest to me, a4 printing near me, affordable printing service near me, automated printing, instant print, local print shops, print copies near me, web print';

/**
 * Hook to set page metadata (title, description, keywords)
 */
const usePageMetadata = ({ title, description, keywords = DEFAULT_KEYWORDS }: PageMetadataProps) => {
  useEffect(() => {
    // Set document title
    document.title = title;
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      document.head.appendChild(meta);
    }
    
    // Meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    } else {
      const keywordsMeta = document.createElement('meta');
      keywordsMeta.name = 'keywords';
      keywordsMeta.content = keywords;
      document.head.appendChild(keywordsMeta);
    }
  }, [title, description, keywords]);
};

export default usePageMetadata;
